export const ADD_EDIT_COURSE = "ADD_EDIT_COURSE";
export const REMOVE_EDITABLE_COURSE = "REMOVE_EDITABLE_COURSE";
